import { Component, Input, OnInit } from '@angular/core';
import { Activity } from '../models';

@Component({
  selector: 'app-strava-stats',
  templateUrl: './strava-stats.component.html',
  styleUrls: ['./strava-stats.component.scss'],
})
export class StravaStatsComponent implements OnInit {

  @Input() activity: Activity;
  @Input() color = 'black';
  constructor() { }

  ngOnInit() {}

}
